var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Vue from "vue";
import { objectToQuery } from "../lib/objectToQuery";
export var fetchReservedAccounts = function (_a, id) {
    var commit = _a.commit;
    // @ts-ignore
    Vue.http.get('dashboard/admin/accounts?account_type=VIRTUAL&merchantId=' + id)
        .then(function (response) {
        commit("setReservedAccounts", __assign({ loading: false }, response.body.data));
    })
        .catch(function (error) {
        // @ts-ignore
        commit("setReservedAccounts", error.body.data ? { error: error.body.data } : null);
    });
};
export var fetchReservedAccountDetails = function (_a, id) {
    var commit = _a.commit;
    // @ts-ignore
    Vue.http.get('dashboard/admin/reserved_vnuban/detail/' + id)
        .then(function (response) {
        commit("setReservedAccountsDetails", __assign({ loading: false }, response.body.data));
    })
        .catch(function (error) {
        // @ts-ignore
        commit("setReservedAccountsDetails", null);
    });
};
export var fetchDashboardBankAccounts = function (_a, id) {
    var commit = _a.commit;
    // @ts-ignore
    Vue.http.get('dashboard/admin/accounts?account_type=BANK&merchantId=' + id)
        .then(function (response) {
        commit("setDashboardBankAccounts", __assign({ loading: false }, response.body.data));
    })
        .catch(function (error) {
        // @ts-ignore
        commit("setDashboardBankAccounts", error.body.data ? { error: error.body.data } : null);
    });
};
export var fetchReservedAccountPayout = function (_a, _b) {
    var commit = _a.commit;
    var _c = _b === void 0 ? { id: '', funding: null, query: {} } : _b, id = _c.id, funding = _c.funding, query = _c.query;
    var recent = funding ? 'funding/' : 'payouts';
    commit("setReservedPayouts", { loading: true });
    var url = !funding ? "dashboard/admin/payouts/list" : 'dashboard/admin/reserved_vnuban/funding/' + id;
    //
    // @ts-ignore
    Vue.http.get("".concat(url).concat(objectToQuery(__assign(__assign({}, query), { account_id: id }))))
        .then(function (response) {
        commit("setReservedPayouts", __assign({ loading: false }, response.body.data));
    })
        .catch(function (error) {
        // @ts-ignore
        commit("setReservedPayouts", error.body.data ? { error: error.body.data } : null);
    });
};
export default {
    fetchReservedAccounts: fetchReservedAccounts,
    fetchReservedAccountDetails: fetchReservedAccountDetails,
    fetchDashboardBankAccounts: fetchDashboardBankAccounts,
    fetchReservedAccountPayout: fetchReservedAccountPayout
};
